import { FilterDriversByCode } from "./../model/personnel.model";
import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Personnel } from "../model/personnel.model";
import { takeUntil } from "rxjs/operators";
import { SaveReportFile } from "projects/sepidz-web-framework/src/lib/models/report-file-save.model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";

@Component({
  selector: "ngx-filter-drivers-by-code",
  templateUrl: "./filter-drivers-by-code.component.html",
  styleUrls: ["./filter-drivers-by-code.component.scss"],
})
export class FilterDriversByCodeComponent extends BaseFormComponent<FilterDriversByCode> {
  lastReportId: number = 0;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private tbService: TabularService) {
    super(selectorService, cd);
    this.setFormGroup();
  }

  async ngOnInit() {
    this.apiName = "";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Parties.FilterDriversByCode.DriverBarcode");
    super.ngOnInit();
  }

  addControl() {
    this.setValue("StartCode", this.model.StartCode);
    this.setValue("EndCode", this.model.EndCode);
    this.setValue("FirstName", this.model.FirstName);
    this.setValue("LastName", this.model.LastName);
    this.cd.markForCheck();
  }

  setdefault() {
    this.model.StartCode = null;
    this.model.EndCode = null;
    this.setValue("StartCode", this.model.StartCode);
    this.setValue("EndCode", this.model.EndCode);
    this.setValue("FirstName", this.model.FirstName);
    this.setValue("LastName", this.model.LastName);
    this.cd.markForCheck();
  }

  applyFilter() {
    const startCode = this.formGroup.controls["StartCode"].value;
    const endCode = this.formGroup.controls["EndCode"].value;

    this.httpCommonService
      .get(`Personnel/GetDriverPersonnel`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Personnel[]) => {
        const sortedData = data.sort((a, b) => a.Number - b.Number);
        const filteredEmployees: Personnel[] = sortedData.filter((employee) => {
          const employeeNumber = Number(employee.Number);
          return employeeNumber >= startCode && employeeNumber <= endCode;
        });

        // const dataSourceString: string = JSON.stringify(filteredEmployees);
        this.apiName = "Personnel";
        const saveReportFile: SaveReportFile = {
          Id: ++this.lastReportId,
          SystemKindName: "SALE", //e.g:"SALE"
          FileName: "driverBarCode.xml", //e.g:"SaleMethodSalesSummaryList.xml" //فایل نیم ریپورت از خانوم خدابنده
          FileInfo: "Personnel", //e.g:null
          CategoryName: "FilterDriversByCode_PersonnelList", //e.g:"SaleReview_SaleMethodSalesSummaryList" \\
          ReportTitle: this.translate("ClientApp.FrontOffice.Parties.FilterDriversByCode.DriverBarcode"), //e.g:"خلاصه فروش به تفکیک نحوه فروش"
          DataSourceName: "Personnel",
        };
        super.tabsservice = this.tbService;
        this.setReport("print", saveReportFile, filteredEmployees);
        this.apiName = "";
      });
  }

  async save(): Promise<void> {
    try {
      this.applyFilter();
      this.close();
    } catch {
      return;
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
